export default __webpack_public_path__ + "static/media/red_waves.c6dfe3df.svg";